var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1A3D82",
    d: "m15.64726,12c0,2.05452 -1.63291,3.72004 -3.64723,3.72004c-2.01434,0 -3.64726,-1.66552 -3.64726,-3.72004c0,-2.05452 1.63292,-3.72004 3.64726,-3.72004c2.01432,0 3.64723,1.66552 3.64723,3.72004zm-1.8236,0c0,1.02727 -0.81648,1.86002 -1.82363,1.86002c-1.00717,0 -1.82363,-0.83275 -1.82363,-1.86002c0,-1.02727 0.81646,-1.86002 1.82363,-1.86002c1.00715,0 1.82363,0.83275 1.82363,1.86002z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1A3D82",
    d: "m12.00001,3.6299c5.09841,0 9.38248,3.55666 10.59702,8.3701c-1.21454,4.81344 -5.49861,8.3701 -10.59702,8.3701c-5.09841,0 -9.38239,-3.55666 -10.59705,-8.3701c1.21465,-4.81344 5.49863,-8.3701 10.59705,-8.3701zm0,14.88017c-4.08087,0 -7.53949,-2.73597 -8.70123,-6.51008c1.16174,-3.77412 4.62036,-6.51008 8.70123,-6.51008c4.08083,0 7.53945,2.73596 8.70117,6.51008c-1.16172,3.7741 -4.62035,6.51008 -8.70117,6.51008z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.a554367ad4cca14c27eaecdadf0a3808.svg";
export { ForwardRef as ReactComponent };